export default __webpack_public_path__ + "static/media/vietgot-screenshot-03.4b8a0bed.png";